// src/lib/sample-data/clubs.ts
import { SAMPLE_DATA_CONFIG, DEFAULT_CLUB } from './config';
import type { Club } from '@/lib/types';
import { format } from 'date-fns';

const defaultOrganizationId = SAMPLE_DATA_CONFIG.defaultOrganizationId;
const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

export const sampleClubsData: Club[] = [
  {
    ...DEFAULT_CLUB,
    id: SAMPLE_DATA_CONFIG.defaultClubId,
    organizationId: defaultOrganizationId,
    contactEmail: 'info@topspintennis.ch',
    contactPhone: '+41 27 456 7890',
    address: {
      addressLine1: "123 Sports Avenue",
      city: "Sierre",
      postalCode: "3960",
      country: "Switzerland"
    },
    calendarStartTime: '08:00',
    calendarEndTime: '23:00',
    billingId: 'acct_topspin_tennis_ch',
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '7384629150',
    name: 'Global Padel Club',
    description: 'Leading padel facilities across Europe',
    status: 'Active',
    sportsOffered: ['Padel'],
    currencyCode: 'EUR',
    contactEmail: 'bookings@globalpadel.com',
    contactPhone: '+44 20 7123 4568',
    address: {
      addressLine1: "109 Charing Cross Road",
      city: "London",
      postalCode: "WC2E 0DT",
      country: "United Kingdom"
    },
    calendarStartTime: '07:00',
    calendarEndTime: '22:00',
    billingId: 'acct_global_padel_uk',
    organizationId: '2951738460', // Global Padel Group
    tenantId: '2951738460',
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '4629385170',
    name: 'Elite Tennis Academy',
    description: 'Professional tennis training and facilities',
    status: 'Active',
    sportsOffered: ['Tennis'],
    currencyCode: 'USD',
    contactEmail: 'academy@elitetennis.org',
    contactPhone: '+1 212 555 0200',
    address: {
      addressLine1: "5th Avenue Courts, 789 Tennis Plaza",
      city: "New York",
      postalCode: "10001",
      country: "USA"
    },
    calendarStartTime: '06:00',
    calendarEndTime: '21:00',
    billingId: 'acct_elite_tennis_ny',
    organizationId: '6174829350', // Urban Tennis Centers
    tenantId: '6174829350',
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '3748591620',
    name: 'Multi-Sport Complex',
    description: 'Diverse sports facilities for all ages',
    status: 'Active',
    sportsOffered: ['Tennis', 'Padel', 'Pickleball', 'Badminton', 'Foot5'],
    currencyCode: 'CHF',
    contactEmail: 'contact@multisport.com',
    contactPhone: '+44 79 23 45 67 90',
    address: {
      addressLine1: "Complexe Sportif",
      city: "Verbier",
      postalCode: "1111",
      country: "Switzerland"
    },
    calendarStartTime: '09:00',
    calendarEndTime: '20:00',
    billingId: 'acct_multisport_paris',
    organizationId: '9516274830', // Lagardère Paris Racing
    tenantId: '9516274830',
    dateCreated: now,
    dateUpdated: now,
  },
  // New clubs
  {
    id: '1928374650',
    name: 'Paris Racing',
    description: 'Historic tennis club in the heart of Paris',
    status: 'Active',
    sportsOffered: ['Tennis'],
    currencyCode: 'EUR',
    contactEmail: 'tennis@parisracing.fr',
    contactPhone: '+33 1 45 67 89 12',
    address: {
      addressLine1: "20 Route de la Muette",
      city: "Paris",
      postalCode: "75016",
      country: "France"
    },
    calendarStartTime: '07:00',
    calendarEndTime: '21:00',
    billingId: 'acct_paris_racing_fr',
    organizationId: '9516274830', // Lagardère Paris Racing
    tenantId: '9516274830',
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '2039485761',
    name: 'Urban London',
    description: 'Modern tennis facilities in central London',
    status: 'Active',
    sportsOffered: ['Tennis', 'Padel'],
    currencyCode: 'GBP',
    contactEmail: 'london@urbantennis.org',
    contactPhone: '+44 20 7456 7890',
    address: {
      addressLine1: "15 Wimbledon Park Road",
      city: "London",
      postalCode: "SW19 7BL",
      country: "United Kingdom"
    },
    calendarStartTime: '06:30',
    calendarEndTime: '22:00',
    billingId: 'acct_urban_london_uk',
    organizationId: '6174829350', // Urban Tennis Centers
    tenantId: '6174829350',
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '3140596872',
    name: 'Urban New York',
    description: 'Premium tennis club in Manhattan',
    status: 'Active',
    sportsOffered: ['Tennis', 'Pickleball'],
    currencyCode: 'USD',
    contactEmail: 'newyork@urbantennis.org',
    contactPhone: '+1 212 555 0300',
    address: {
      addressLine1: "Central Park West, 200",
      city: "New York",
      postalCode: "10024",
      country: "USA"
    },
    calendarStartTime: '06:00',
    calendarEndTime: '23:00',
    billingId: 'acct_urban_newyork_us',
    organizationId: '6174829350', // Urban Tennis Centers
    tenantId: '6174829350',
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '4251607983',
    name: 'Urban Tokyo',
    description: 'State-of-the-art tennis facilities in Tokyo',
    status: 'Active',
    sportsOffered: ['Tennis', 'Badminton'],
    currencyCode: 'JPY',
    contactEmail: 'tokyo@urbantennis.org',
    contactPhone: '+81 3 1234 5678',
    address: {
      addressLine1: "1-1-1 Shibuya",
      city: "Tokyo",
      postalCode: "150-0002",
      country: "Japan"
    },
    calendarStartTime: '07:00',
    calendarEndTime: '22:00',
    billingId: 'acct_urban_tokyo_jp',
    organizationId: '6174829350', // Urban Tennis Centers
    tenantId: '6174829350',
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '5362719094',
    name: 'All England Lawn Tennis',
    description: 'Prestigious grass court tennis club',
    status: 'Active',
    sportsOffered: ['Tennis'],
    currencyCode: 'CHF',
    contactEmail: 'info@allenglandlawn.ch',
    contactPhone: '+41 27 789 0123',
    address: {
      addressLine1: "Church Road, 1",
      city: "Wimbledon",
      postalCode: "SW19 5AE",
      country: "Switzerland"
    },
    calendarStartTime: '08:00',
    calendarEndTime: '20:00',
    billingId: 'acct_allengland_ch',
    organizationId: defaultOrganizationId, // Courtly Sports Inc.
    tenantId: defaultOrganizationId,
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '6473820195',
    name: 'Alpine Sports Center',
    description: 'Mountain sports facility with tennis and padel courts',
    status: 'Active',
    sportsOffered: ['Tennis', 'Padel'],
    currencyCode: 'CHF',
    contactEmail: 'info@alpinesports.ch',
    contactPhone: '+41 27 123 4567',
    address: {
      addressLine1: "Mountain View Road, 45",
      city: "Zermatt",
      postalCode: "3920",
      country: "Switzerland"
    },
    calendarStartTime: '07:00',
    calendarEndTime: '22:00',
    billingId: 'acct_alpine_sports_ch',
    organizationId: defaultOrganizationId, // Courtly Sports Inc.
    tenantId: defaultOrganizationId,
    dateCreated: now,
    dateUpdated: now,
  },
  {
    id: '7584931206',
    name: 'Lake Geneva Tennis Club',
    description: 'Exclusive lakeside tennis facilities',
    status: 'Active',
    sportsOffered: ['Tennis'],
    currencyCode: 'CHF',
    contactEmail: 'contact@lakegeneva.ch',
    contactPhone: '+41 22 987 6543',
    address: {
      addressLine1: "Lakeside Promenade, 12",
      city: "Montreux",
      postalCode: "1820",
      country: "Switzerland"
    },
    calendarStartTime: '08:00',
    calendarEndTime: '21:00',
    billingId: 'acct_lakegeneva_ch',
    organizationId: defaultOrganizationId, // Courtly Sports Inc.
    tenantId: defaultOrganizationId,
    dateCreated: now,
    dateUpdated: now,
  },
  // Add more clubs as needed
];

// Export sampleClubs
export const sampleClubs = sampleClubsData;
